@if (shouldRender()) {
<section
  class="block-tabbed-carousel"
  [class.block-tabbed-carousel--surface-primary]="surface() === 'primary'"
>
  <div class="block-tabbed-carousel__inner">
    <header class="block-tabbed-carousel__header">
      <h2 class="block-tabbed-carousel__title">{{ title() }}</h2>
      <a class="block-tabbed-carousel__view-all" [routerLink]="viewAllLink()">
        {{ viewAllLabel() }}
        <app-icon [icon]="arrowRightIcon" [size]="16" />
      </a>
    </header>

    @if (tabs().length > 0) {
      <div
        class="block-tabbed-carousel__tabs"
        role="tablist"
        [attr.aria-label]="ariaLabel()"
      >
        @for (tab of tabs(); track tab.category.id) {
          <button
            class="block-tabbed-carousel__tab"
            [class.block-tabbed-carousel__tab--active]="isActive(tab.category.id)"
            type="button"
            role="tab"
            [attr.aria-selected]="isActive(tab.category.id)"
            (click)="selectCategory(tab.category.id)"
          >
            {{ tab.category.name }}
          </button>
        }
      </div>
    }

    <app-product-carousel
      [products]="activeProducts()"
      [loading]="loading()"
      [autoplay]="true"
      [autoplayMs]="5000"
      [showPagination]="true"
      [arrowsOnHover]="true"
      (addToCart)="addToCart.emit($event)"
      (zoomOpen)="zoomOpen.emit($event)"
      (notifyRequest)="notifyRequest.emit($event)"
      (notifyCancel)="notifyCancel.emit($event)"
      (cardClick)="cardClick.emit($event)"
      (reserveClick)="reserveClick.emit($event)"
    />

    @if (errored()) {
      <p class="block-tabbed-carousel__error">
        {{ errorMessage() }}
      </p>
    }
  </div>
</section>
}
